import { render, staticRenderFns } from "./FiltroRastreabilidade.vue?vue&type=template&id=667641cc&scoped=true&lang=pug"
import script from "./FiltroRastreabilidade.vue?vue&type=script&lang=js"
export * from "./FiltroRastreabilidade.vue?vue&type=script&lang=js"
import style0 from "./FiltroRastreabilidade.vue?vue&type=style&index=0&id=667641cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667641cc",
  null
  
)

export default component.exports